import React from 'react';

import { type I18NMessages, IntlMessagesProvider } from '@atlaskit/intl-messages-provider';

import messages from '../../../i18n/en';

import { asyncLanguages } from './async-languages';

export function AsyncIntlProvider({ children }: { children: React.ReactNode }) {
	return (
		<IntlMessagesProvider defaultMessages={messages} loaderFn={fetchMessagesForLocale}>
			{children}
		</IntlMessagesProvider>
	);
}

async function fetchMessagesForLocale(locale: string): Promise<I18NMessages | undefined> {
	try {
		// Fallback to the generic locale if specified one is not found
		const languageLocale = locale in asyncLanguages ? locale : locale.split(/[-_]/)[0] || '';

		// Dynamic import of the locale file
		const localeMessages = (await asyncLanguages[languageLocale]?.()) as
			| { default: I18NMessages }
			| undefined;

		return localeMessages?.default ?? messages;
	} catch {
		// ignore
	}

	return messages;
}
